var _slicedToArray = require("/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["   \n  border-top-width: 7px;\n  border-top-color: ", ";\n  border-top-style: solid;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  box-shadow: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  @media (min-width: ", "em) {\n    display: none;\n  }\n  @media (min-width: ", "em) {\n    display: inherit;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  box-shadow: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types'), require('styled-components'), require('@rebass/grid'), require('@rtm-ui/theme'), require('react-scroll')) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', 'styled-components', '@rebass/grid', '@rtm-ui/theme', 'react-scroll'], factory) : (global = global || self, factory(global.layout = {}, global.React, global.PropTypes, global.styled, global.RebassGrid, global.RtmUiTheme, global.ReactScroll));
})(this, function (exports, React, PropTypes, styled, grid, theme, reactScroll) {
  'use strict';

  var React__default = 'default' in React ? React['default'] : React;
  PropTypes = PropTypes && Object.prototype.hasOwnProperty.call(PropTypes, 'default') ? PropTypes['default'] : PropTypes;
  styled = styled && Object.prototype.hasOwnProperty.call(styled, 'default') ? styled['default'] : styled;

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var Wrapper = styled(grid.Box)(_templateObject(), function (props) {
    return props.showBackground && theme.backgroundStyle;
  }, function (props) {
    return props.backgroundColor && "background: ".concat(theme.getColor(props.backgroundColor, props.theme));
  }, function (props) {
    return props.scale && "font-size: ".concat(props.theme.basePx * props.scale, "px");
  }, function (props) {
    return theme.getColor(props.backgroundColor, props.theme);
  });

  var Box = function Box(_ref) {
    var variant = _ref.variant,
        gridProps = _objectWithoutProperties(_ref, ["variant"]);

    return variant ?
    /*#__PURE__*/
    React__default.createElement(theme.Theme, {
      variant: variant
    },
    /*#__PURE__*/
    React__default.createElement(Wrapper, _extends({
      showBackground: true
    }, gridProps))) :
    /*#__PURE__*/
    React__default.createElement(Wrapper, gridProps);
  };

  Box.propTypes = {
    variant: PropTypes.string,
    backgroundColor: PropTypes.string
  };
  var Wrapper$1 = styled(Box)(_templateObject2(), function (_ref2) {
    var rounded = _ref2.rounded,
        theme = _ref2.theme;
    return rounded ? theme.borderRadius : '0';
  }, function (_ref3) {
    var elevation = _ref3.elevation,
        theme = _ref3.theme;
    return elevation ? theme.elevation[elevation] : 'none';
  });

  var Pane = function Pane(props) {
    return (
      /*#__PURE__*/
      React__default.createElement(Wrapper$1, props)
    );
  };

  Pane.propTypes = {
    children: PropTypes.node.isRequired
  };
  var StyledBlock = styled(Box)(_templateObject3(), function (props) {
    return props.showAt ? "display: none" : null;
  }, function (props) {
    return props.theme.grid[props.hideAt];
  }, function (props) {
    return props.theme.grid[props.showAt];
  });

  var Block = function Block(_ref4) {
    var hideAt = _ref4.hideAt,
        showAt = _ref4.showAt,
        children = _ref4.children,
        rest = _objectWithoutProperties(_ref4, ["hideAt", "showAt", "children"]);

    return (
      /*#__PURE__*/
      React__default.createElement(StyledBlock, _extends({
        hideAt: hideAt,
        showAt: showAt
      }, rest), children)
    );
  };

  Block.propTypes = {
    hideAt: PropTypes.oneOf(['sm', 'md', 'lg']),
    showAt: PropTypes.oneOf(['sm', 'md', 'lg']),
    children: PropTypes.node.isRequired
  };
  var Wrapper$2 = styled(Pane)(_templateObject4(), function (_ref5) {
    var theme = _ref5.theme;
    return theme.borderRadius;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.boxShadow;
  });

  var Card = function Card(_ref7) {
    var children = _ref7.children,
        boxProps = _objectWithoutProperties(_ref7, ["children"]);

    return (
      /*#__PURE__*/
      React__default.createElement(Wrapper$2, _extends({
        rounded: true,
        showBackground: true,
        elevation: "2"
      }, boxProps), children)
    );
  };

  Card.propTypes = {
    children: PropTypes.node.isRequired
  };
  var Wrapper$3 = styled(grid.Flex)(_templateObject5(), function (props) {
    return props.showBackground && theme.backgroundStyle;
  }, function (props) {
    return props.backgroundColor && "background: ".concat(theme.getColor(props.backgroundColor, props.theme));
  });

  var Flex = function Flex(_ref8) {
    var children = _ref8.children,
        variant = _ref8.variant,
        gridProps = _objectWithoutProperties(_ref8, ["children", "variant"]);

    return variant ?
    /*#__PURE__*/
    React__default.createElement(theme.Theme, {
      variant: variant
    },
    /*#__PURE__*/
    React__default.createElement(Wrapper$3, _extends({
      showBackground: true
    }, gridProps), children)) :
    /*#__PURE__*/
    React__default.createElement(Wrapper$3, gridProps, children);
  };

  Flex.propTypes = {
    children: PropTypes.node,
    variant: PropTypes.string
  };

  function getSize() {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }

  function useWindowSize() {
    var _React$useState = React.useState(getSize()),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        windowSize = _React$useState2[0],
        setWindowSize = _React$useState2[1];

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener('resize', handleResize);
    React.useEffect(function () {
      window.addEventListener('resize', handleResize);
      return function () {
        window.removeEventListener('resize', handleResize);
      };
    }, [windowSize]);
    return windowSize;
  }
  /**
   * ScrollTo functionality with added config option.
   *
   * Note: the passed "ref" needs to match the "name" tag for the specific item being scrolled to
   *
   * e.g. `ref = "itemA"` | `<div name="itemA" />`
   *
   * See https://github.com/fisshy/react-scroll for more information on configuration options
   *
   * @param {*} e
   * @param {string} ref
   * @param {{DURATION? : number, smooth?: boolean, offsetY?: number, delay?: number}} config
   *
   *
   */


  function scrollToElementExtended(e, ref, config) {
    if (e) {
      e.preventDefault();
    }

    if (config == undefined) {
      // Prevents expection being throwning in the event of "config" not being supplied
      // Assumes default values in this case.
      config = {};
    } // react-scroll


    reactScroll.scroller.scrollTo(ref, {
      duration: config.DURATION || 750,
      smooth: config.smooth || true,
      offset: config.offsetY || -100,
      delay: config.delay || 0
    });
  }

  function scrollToElement(e, ref) {
    if (e) {
      e.preventDefault();
    }

    var anchor = document.querySelector("[scroll-target='".concat(ref, "']"));
    var offset = window.scrollY + anchor.getBoundingClientRect().top; // Y

    window.scrollTo({
      left: 0,
      top: offset - 100,
      behavior: 'smooth'
    });
  }

  function useElementVisible(elem) {
    var _React$useState3 = React.useState(),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        visible = _React$useState4[0],
        setVisible = _React$useState4[1]; // for inital setup


    React.useEffect(function () {
      handleScroll();
    });

    function handleScroll() {
      setVisible(elementIsVisible(elem));
    }

    window.addEventListener('scroll', handleScroll);
    React.useEffect(function () {
      window.addEventListener('scroll', handleScroll);
      return function () {
        window.removeEventListener('scroll', handleScroll);
      };
    }, [visible]);
    return visible;
  }
  /**
   * Check if the element is inside the visible viewport
   * return true/false
   * element passed is a dom element and not an object
   */

  /* istanbul ignore next */


  function elementIsVisible(element) {
    var elem = document.querySelector(element);

    if (!elem) {
      return 'invalid element';
    }

    var scroll = window.scrollY || window.pageYOffset;
    var boundsTop = elem.getBoundingClientRect().top + scroll;
    var viewport = {
      top: scroll,
      bottom: scroll + window.innerHeight
    };
    var bounds = {
      top: boundsTop,
      bottom: boundsTop + elem.clientHeight
    };
    return bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom || bounds.top <= viewport.bottom && bounds.top >= viewport.top;
  }

  function generateAbsoluteUrl(href) {
    if (href && (href.indexOf('http://') === 0 || href.indexOf('https://') === 0)) {
      // do nothing
      return href;
    } else if (href && href.indexOf('www.') === 0) {
      return "//".concat(href);
    } else {
      return href;
    }
  }

  var Wrapper$4 = styled(Card)(_templateObject6(), function (props) {
    return theme.getColor(props.bordercolor, props.theme);
  });

  var TopBorderCard = function TopBorderCard(props) {
    return (
      /*#__PURE__*/
      React__default.createElement(Wrapper$4, _extends({
        bordercolor: "primary"
      }, props))
    );
  };

  TopBorderCard.propTypes = {
    children: PropTypes.node.isRequired
  };
  exports.Block = Block;
  exports.Box = Box;
  exports.Card = Card;
  exports.Flex = Flex;
  exports.Pane = Pane;
  exports.TopBorderCard = TopBorderCard;
  exports.generateAbsoluteUrl = generateAbsoluteUrl;
  exports.scrollToElement = scrollToElement;
  exports.scrollToElementExtended = scrollToElementExtended;
  exports.useElementVisible = useElementVisible;
  exports.useWindowSize = useWindowSize;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});